import React, { useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { useHistory } from 'react-router-dom';
import block from 'bem-cn';

import Spinner from 'components/Spinner/view/desktop';
import useRequestHistory from 'features/reports/model/requestHistory/useRequestHistory';

import FilterBlock from './FilterBlock';
import Table from './Table';

import './RequestHistory.scss';

const b = block('request-history-desktop');

const RequestHistory = () => {
  const history = useHistory();
  const model = useRequestHistory();

  const { actionProcessing } = useSelector(state => state.reports, shallowEqual);
  const semiAutoWithdrawalEnabled = useSelector(state => state.auth.semiAutoWithdrawalEnabled);

  useEffect(() => {
    if (!semiAutoWithdrawalEnabled) {
      history.push('/');
    }
  }, [semiAutoWithdrawalEnabled, history]);
  if (!semiAutoWithdrawalEnabled) {
    return <Spinner isLoading={actionProcessing} />;
  }
  return (
    <div className={b()}>
      <Spinner isLoading={actionProcessing} />
      <FilterBlock model={model} />
      <Table model={model} />
    </div>
  );
};

export default RequestHistory;
